/**
 * Hinweis, wenn jemand nicht prüfen darf.
 *
 * Die Trennung ist gewollt: die Administration verwaltet, sie prüft nicht.
 * Falsch war, die Knöpfe dafür einfach auszublenden — dann sieht die
 * Anwendung kaputt aus, und man sucht den fehlenden Knopf, statt die Regel
 * zu verstehen. Eine Regel, die man nicht sieht, ist keine Regel, sondern
 * ein Fehler.
 *
 * Deshalb steht hier, warum es nicht geht und was zu tun ist. Zwei Wege,
 * beide ohne Umweg über mich.
 */

import { Link } from 'react-router-dom'
import { ROLLENTEXT } from '../api/typen'
import { darfVerwalten, useKonto } from '../konto/KontoKontext'

export function NurPruefer({ was }: { was: string }) {
  const { konto } = useKonto()
  if (!konto) return null

  return (
    <div className="karte border-stufe-2 bg-stufe-2-grund">
      <p className="font-bold text-stufe-2">
        {was} ist Ihrer Rolle nicht möglich
      </p>
      <p className="mt-1 text-base">
        Sie sind als <span className="font-semibold">{ROLLENTEXT[konto.rolle]}</span>{' '}
        angemeldet. Prüfen dürfen Inhaber und Prüfer — die Administration
        verwaltet, sie beurteilt nicht. So steht im Bericht immer, wer
        tatsächlich vor Ort war.
      </p>

      <ul className="mt-2 space-y-1 text-base">
        <li>
          <span className="font-semibold">Sie prüfen selbst?</span> Dann gehört
          Ihr Konto auf <span className="font-semibold">Inhaber</span> — das darf
          beides.
          {darfVerwalten(konto) && (
            <>
              {' '}
              <Link to="/verwaltung" className="text-akzent-700 underline">
                In der Verwaltung ändern
              </Link>
            </>
          )}
        </li>
        <li>
          <span className="font-semibold">Nur zum Ansehen?</span> Übernehmen Sie in
          der Verwaltung die Ansicht eines Prüfers. Das wird festgehalten, und der
          Bericht trägt weiterhin dessen Namen.
        </li>
      </ul>
    </div>
  )
}
